import UserIcon from '@assets/icons/UserIcon';
import AvatarHandler from '@components/Global/AvatarHandler/AvatarHandler';
import { DropDownPicker } from '@constants/Themed';
import { AntDesign } from '@expo/vector-icons';
import toTitleCase from '@hooks/toTitleCase';
import styles from '@stylesheet';
import React, { useEffect, useState } from 'react';
import { View, Text, Image, ImageStyle, ViewStyle, Platform } from 'react-native';
import * as Animatable from 'react-native-animatable';
import { SizableText, XStack, YStack } from 'tamagui';
import { Badge } from '@constants/Themed'

interface UserListItemProps {
  item: string | { id: string, name: string, surname: string, email: string, avatar: string | { img: string } };
  index?: number;
  filterUser?: (id: string) => void;
  row?: boolean;
  removePermission?: boolean;
  textColor?: string;
  hideEmail?: boolean;
  avatarImageStyle?: ImageStyle;
  inverse?: boolean;
  hideDetails?: boolean;
  containerStyle?: ViewStyle;
  size?: 'large' | 'small';
}

const UserListItem = ({
  size,
  containerStyle,
  hideDetails,
  inverse,
  avatarImageStyle,
  hideEmail = false,
  item,
  textColor,
  index,
  row,
  removePermission = false,
  filterUser
}: UserListItemProps) => {

  const [userItem, setUserItem] = useState(() => (typeof item === "object" ? item : null));
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [items, setItems] = useState([
    { label: 'Admin', value: 'admin' },
    { label: 'Common', value: 'common' }
  ]);

  useEffect(() => {
    if (typeof item === "object" && item?.profile_information) {
      setUserItem(item.profile_information);
    }
  }, [item]);

  if (!item || item === 'localhost' || item === 'web') {
    return (
      <Animatable.View useNativeDriver animation="bounceIn" style={{ flexDirection: row ? (inverse ? "column-reverse" : "column") : (inverse ? "row-reverse" : "row"), gap: 10, flex: 1, marginVertical: 10, ...containerStyle }}>
        <Image
          source={require('@assets/icons/cloud-connection.svg')}
          style={[
            styles.centerEverything,
            {
              aspectRatio: 1,
              borderColor: "white",
              width: 50,
              height: 50,
              borderRadius: avatarImageStyle?.width ? avatarImageStyle?.width / 2 : 50
            },
            avatarImageStyle
          ]}
        />
      </Animatable.View>
    );
  }

  return (
    <Animatable.View useNativeDriver
      animation="bounceIn"
      style={{
        flexDirection: row ? (inverse ? "column-reverse" : "column") : (inverse ? "row-reverse" : "row"),
        gap: 10,
        flex: 1,
        marginVertical: 10,
        ...containerStyle
      }}
    >
      <XStack rowGap={20} flexDirection={row ? 'column' : 'row'} flex={1} gap={10} flexWrap="wrap">
        <XStack gap={10} flexDirection={row ? 'row' : 'column'} flex={1}>
          <AvatarHandler
            avatar={userItem?.avatar}
            avatarImageStyle={{
              flex: 19,
              width: Platform.select({ web: 50, default: 30 }),
              height: Platform.select({ web: 50, default: 30 }),
              borderRadius: 50,
              ...avatarImageStyle
            }}
            replacementImageStyle={{
              top: -5,
              flex: 19,
              minWidth: Platform.select({ web: 50, default: 35 }),
              minHeight: Platform.select({ web: 50, default: 35 }),
              borderRadius: 50,
            }}
          />
          {item?.count && (
            <Badge style={{ position: 'absolute', left: Platform.select({native: -12}), top: -8, shadowRadius: 20, shadowOpacity: .2, fontWeight: "bold", zIndex: 10, backgroundColor: '#dcd15e', borderRadius: 20, padding: 5 }}><Text>{item?.count}</Text></Badge>
          )}
          {!hideDetails && (
            <View style={{ flexDirection: "column", flex: 5, gap: 0, minWidth: "55%", justifyContent: 'center' }}>
              <Text style={{ top: !userItem?.avatar && -5, minHeight: 20, fontSize: size === 'large' ? 32 : undefined, flexWrap: 'wrap', textAlign: "center", color: textColor || undefined, fontWeight: '600' }}>
                {toTitleCase(userItem?.name) || `Inviting user to join your company: \n ${userItem?.email}`} {toTitleCase(userItem?.surname) || ""}
              </Text>
              {!hideEmail && (
                <Text style={{ textAlign: "center", color: textColor || undefined, fontWeight: '400' }}>
                  {userItem?.email || ""}
                </Text>
              )}
            </View>
          )}
        </XStack>
        {!removePermission && (
          <DropDownPicker
            open={open}
            style={[styles.dropdownInput, { flex: 1, maxHeight: 50, top: -20 }]}
            dropDownContainerStyle={{ maxWidth: 120 }}
            closeAfterSelecting={true}
            placeholder="Role"
            setOpen={setOpen}
            items={items}
            value={value}
            setValue={setValue}
          />
        )}
      </XStack>
    </Animatable.View>
  );
};

export default UserListItem;
